import { FC, useEffect, useRef } from 'react';
import { Box, Skeleton } from '@mui/material';
import { grey } from '@mui/material/colors';
import useBraintreeInstance from '@acorn-portal/shared/src/hooks/use-braintree-instance';
import { useBraintreeContext } from '@acorn-portal/shared/src/context/braintree-context';

interface IProps {
	clientToken: string;
	amount?: string;
	isOptOut: boolean;
	cardOnly?: boolean;
	noPayPal?: boolean;
	noMobileWallets?: boolean;
}

const BraintreeDropinContainer: FC<IProps> = ({
	clientToken,
	amount,
	isOptOut,
	cardOnly,
	noPayPal,
	noMobileWallets,
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const { setInstance } = useBraintreeContext();
	const instance = useBraintreeInstance({
		clientToken,
		amount,
		isOptOut,
		cardOnly,
		noPayPal,
		noMobileWallets,
	});

	useEffect(() => {
		if (instance) {
			setInstance(instance);
		}
	}, [instance, setInstance]);

	return (
		<Box
			sx={(theme) => ({
				'& #dropin-container': {
					'& .braintree-toggle': {
						backgroundColor: grey[300],
						fontSize: theme.typography.fontSize,
					},
				},
			})}
		>
			<Box
				sx={{
					display: instance ? 'block' : 'none',
				}}
				id='dropin-container'
				ref={ref}
			/>
			{!instance && <Skeleton variant='rectangular' animation='wave' height={200} />}
		</Box>
	);
};

export default BraintreeDropinContainer;
